var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "94.713 85.352 20 16",
    width: "20px",
    height: "16px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2369_2062",
    x1: -0.362867,
    y1: 12.3591,
    x2: 20.326,
    y2: 12.3591,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1, 0, 0, 1, 94.712936, 81.328178)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#895EF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F03063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7640"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 96.713 101.352 C 96.163 101.352 95.692 101.156 95.3 100.764 C 94.909 100.372 94.713 99.902 94.713 99.352 L 94.713 87.352 C 94.713 86.802 94.909 86.331 95.3 85.939 C 95.692 85.547 96.163 85.352 96.713 85.352 L 112.713 85.352 C 113.263 85.352 113.734 85.547 114.125 85.939 C 114.517 86.331 114.713 86.802 114.713 87.352 L 114.713 99.352 C 114.713 99.902 114.517 100.372 114.125 100.764 C 113.734 101.156 113.263 101.352 112.713 101.352 L 96.713 101.352 Z M 104.713 94.352 L 96.713 89.352 L 96.713 99.352 L 112.713 99.352 L 112.713 89.352 L 104.713 94.352 Z M 104.713 92.352 L 112.713 87.352 L 96.713 87.352 L 104.713 92.352 Z M 96.713 89.352 L 96.713 87.352 L 96.713 99.352 L 96.713 89.352 Z",
    fill: "url(#paint0_linear_2369_2062)",
    id: "object-0",
    transform: "matrix(1, 0, 0, 1, 0, -1.4210854715202004e-14)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailB);
export default __webpack_public_path__ + "static/media/mail-b.7df9bfc4c7b364052ea734b144eda1fc.svg";
export { ForwardRef as ReactComponent };